/*
 * @Author: guohci
 * @Descripttion: 
 * @Date: 2023-11-03 15:45:57
 * @LastEditTime: 2023-11-03 15:45:57
 */
import React, { useEffect, useState } from 'react';

export default function (props) {
    const [isShow, setIsShow] = useState(false);
    useEffect(() => {
        const intersectionObserver = new IntersectionObserver(entries => {
            // 如果 intersectionRatio 为 0，则目标在视野外，
            // 我们不需要做任何事情。
            if (entries[0].intersectionRatio <= 0) { return; }
            setIsShow(true);
        });
        const domObserver = document.getElementById(props.observerId);
        // 开始监听
        domObserver && intersectionObserver.observe(domObserver);
    });
    return (
        <>
            {isShow && (props.children)}
        </>
    );
}
